import { appConnector } from 'shared/connector'

import type { Profile } from './types'

import { apiRTK } from '../api-rtk'

export const connectorApi = apiRTK.injectEndpoints({
	endpoints: create => ({
		captureLinkedIn: create.mutation<Profile, void>({
			async queryFn() {
				try {
					const data = await appConnector.linkedIn.captureCurrentProfile()
					return { data }
				} catch (error) {
					return { error }
				}
			}
		}),

		signInUnderTeamMember: create.mutation<boolean, string>({
			async queryFn(id) {
				const signIn = appConnector.auth.signInUnderTeamMember

				try {
					await signIn(id)
					return { data: true }
				} catch (error) {
					return { error }
				}
			}
		}),

		signOut: create.mutation<boolean, void>({
			async queryFn() {
				const signOut = appConnector.auth.signOut

				try {
					await signOut()
					return { data: true }
				} catch (error) {
					return { error }
				}
			}
		}),

		stopMemberSession: create.mutation<boolean, void>({
			async queryFn() {
				const signOut = appConnector.auth.signOutUnderTeamMember

				try {
					await signOut()
					return { data: true }
				} catch (error) {
					return { error }
				}
			}
		})
	}),
	overrideExisting: true
})
